export default "__VITE_ASSET__BOhbJfi2__"